import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "system-attachments" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-xs-12" };
const _hoisted_4 = {
    key: 0,
    class: "row"
};
const _hoisted_5 = { class: "col-xs-12 bottom20" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cloud-upload fa-3x" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "top10" }, "Click to upload or drag and drop files here", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "text-muted" }, "Supported: Documents (PDF, DOC, DOCX, XLS, XLSX, TXT, CSV), Images (JPG, PNG, GIF), Videos (MP4, AVI, MOV)", -1 /* HOISTED */);
const _hoisted_9 = {
    key: 1,
    class: "row"
};
const _hoisted_10 = { class: "attachment-card" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 2,
    class: "document-icon"
};
const _hoisted_15 = { class: "file-extension" };
const _hoisted_16 = { class: "attachment-info" };
const _hoisted_17 = ["title"];
const _hoisted_18 = { class: "attachment-size text-muted" };
const _hoisted_19 = {
    key: 0,
    class: "attachment-actions"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_21 = {
    key: 2,
    class: "row"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", { class: "col-xs-12" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-muted text-center top20" }, "No attachments")
], -1 /* HOISTED */);
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = { class: "preview-content" };
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
const _hoisted_27 = {
    key: 2,
    class: "text-center"
};
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", null, "Preview not available for this file type.", -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_30 = {
    key: 0,
    class: "text-center top20"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
            ])
        ]),
        _createTextVNode(),
        (_ctx.canEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["upload-area", { 'dragging': _ctx.isDragging }]),
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
                        onDrop: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
                        onDragover: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                        onDragenter: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.isDragging = true), ["prevent"])),
                        onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.isDragging = false), ["prevent"]))
                    }, [
                        _hoisted_6,
                        _createTextVNode(),
                        _hoisted_7,
                        _createTextVNode(),
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            type: "file",
                            ref: "fileInput",
                            onChange: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
                            multiple: "",
                            accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.jpg,.jpeg,.png,.gif,.mp4,.avi,.mov",
                            style: { "display": "none" }
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
                    ], 34 /* CLASS, NEED_HYDRATION */)
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        (_ctx.attachments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "col-xs-12 col-sm-6 col-md-4 col-lg-3 mt-2",
                        key: attachment.systemAttachmentId || attachment.tempId
                    }, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", {
                                class: "attachment-preview",
                                onClick: ($event) => (_ctx.previewAttachment(attachment))
                            }, [
                                (_ctx.isImage(attachment))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.getPreviewUrl(attachment),
                                        alt: "preview"
                                    }, null, 8 /* PROPS */, _hoisted_12))
                                    : (_ctx.isVideo(attachment))
                                        ? (_openBlock(), _createElementBlock("video", {
                                            key: 1,
                                            src: _ctx.getPreviewUrl(attachment),
                                            loop: "",
                                            muted: "",
                                            autoplay: "",
                                            playsinline: ""
                                        }, null, 8 /* PROPS */, _hoisted_13))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(_ctx.getDocumentIcon(attachment))
                                            }, null, 2 /* CLASS */),
                                            _createTextVNode(),
                                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getFileExtension(attachment.fileName)), 1 /* TEXT */)
                                        ]))
                            ], 8 /* PROPS */, _hoisted_11),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("p", {
                                    class: "attachment-name",
                                    title: attachment.fileName
                                }, _toDisplayString(attachment.fileName), 9 /* TEXT, PROPS */, _hoisted_17),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.formatFileSize(attachment)), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            (_ctx.canEdit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_b_button, {
                                        variant: "outline-danger",
                                        size: "sm",
                                        onClick: ($event) => (_ctx.deleteAttachment(attachment))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_20
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)),
        _createTextVNode(),
        _createCommentVNode(" Preview Modal "),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.showPreview,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.showPreview) = $event)),
            size: "xl",
            title: (_a = _ctx.previewFile) === null || _a === void 0 ? void 0 : _a.fileName,
            "hide-footer": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                    (_ctx.isImage(_ctx.previewFile))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.getPreviewUrl(_ctx.previewFile),
                            class: "img-fluid"
                        }, null, 8 /* PROPS */, _hoisted_25))
                        : (_ctx.isVideo(_ctx.previewFile))
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 1,
                                src: _ctx.getPreviewUrl(_ctx.previewFile),
                                controls: "",
                                class: "video-fluid"
                            }, null, 8 /* PROPS */, _hoisted_26))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _hoisted_28,
                                _createTextVNode(),
                                _createVNode(_component_b_button, {
                                    variant: "primary",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.downloadAttachment(_ctx.previewFile)))
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_29,
                                        _createTextVNode(" Download\r\n\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]))
                ]),
                _createTextVNode(),
                (_ctx.isImage(_ctx.previewFile) || _ctx.isVideo(_ctx.previewFile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.downloadAttachment(_ctx.previewFile)))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_31,
                                _createTextVNode(" Download\r\n\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "title"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Processing..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
